/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_positionDescriptionCtrl', ['$sce','$scope','$rootScope', '$http', 'NetworkService', 'MainService', function ($sce, $scope,$rootScope, $http, NetworkService, MainService) {



       $rootScope.$on("updateDialogView", function(){
           var data = MainService.getDialogData("dialog_moveUserCtrl")
           data.position_description = $sce.trustAsHtml(data.position_description);
           $scope.data = data;
           setTimeout(function(){
             coordinates = data.Meetingpointcoordinates.split(",");
             if(coordinates.length = 2)
             {
               initMap(coordinates)
             }
           },500)

           var id = $scope.data.position_id
           $scope.img = "./imgs/positionImgs/position_"+id+".png"
       })
    }])
